
import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Outlet } from "react-router-dom";
import OrderHeaderLayout from "./OrderHeaderLayout";

const OrderLayout = () => {
	return (
		<Box>
			<OrderHeaderLayout />

			<Container maxWidth="lg" sx={{ mt: 2 }}>
				<Outlet />
			</Container>
		</Box>
	);
};

export default OrderLayout;

